import SortUtils from "../../SortUtils";


export default class CheckListItemUtils extends SortUtils{
  
  static SortByIndex = function(a, b) {
    var aindex = a.index();
    var bindex = b.index();
    return aindex - bindex;
  }
  
}